import React from 'react';
import PropTypes from 'prop-types';
import './masterBar.scss';
import { INITIAL } from 'utils/initalPath';
import { getChilds, getPlace } from 'dataProvider';
import { excludedGrandParentIds } from 'core/constants';
import { getSite } from '../../constants/sites';

import { NAVIGATION_MODE } from '../../constants';

const ELECTION_NAME_VALUES = {
  REGIONAL: 'Autonómicas',
  MUNICIPAL: 'Municipales'
};

const MasterBar = ({
  history,
  params,
  match,
  optionalTitleRegular,
  optionalTitleStrong,
  placePactL6
}) => {
  const {
    type,
    electionNumber,
    navigableMode,
    chartType,
    showMasterBar,
    year,
    placesId,
    community,
    placeId,
    allMap
  } = match.params;

  const isOpenedTabs = Number(showMasterBar);

  const goToDetails = (child, event) => {
    // if (Number(navigableMode) !== NAVIGATION_MODE.INTERNAL) {
    //   return;
    // }
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // ñapa para guardar altura de los módulos al cambiar de tab
    const modules = document.body.querySelectorAll('._main');
    if (modules.length && !window.isElectionsModulesHeightSet) {
      window.isElectionsModulesHeightSet = true;
      modules.forEach(module => {
        const moduleHeight = module.offsetHeight;
        module.style.height = `${moduleHeight}px`;
      });
    }

    const childType = child.name
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
    const intialPath = INITIAL();

    if (placePactL6) {
      if (childType === 'MUNICIPALES') {
        getPlace({
          filter: `typeplace=TOWN&size=1&grandpaid=${placePactL6.ineId}&sortby=main`,
          electionType: 'MUNICIPAL'
        }).then(p => {
          history.push(
            `/0/${year}/MUNICIPAL/${electionNumber}/${showMasterBar}/${p.content[0].ineId}/rankingPactometro.html`
          );
        });
      }
      if (childType === 'AUTONOMICAS') {
        if (!excludedGrandParentIds.includes(placePactL6.grandpaId)) {
          history.push(
            `/0/${year}/REGIONAL/${electionNumber}/${showMasterBar}/${placePactL6.grandpaId}/rankingPactometro.html`
          );
          return;
        }
        history.push(
          `/0/${year}/REGIONAL/${electionNumber}/${showMasterBar}/R13/rankingPactometro.html`
        );
        return;
      }
    }

    if (childType === 'AUTONOMICAS') {
      if (intialPath.includes('home-multiply-regional-resultados.html')) {
        history.push(intialPath);

        return;
      }
      history.push(
        `/C108/${navigableMode}/2023/REGIONAL/${electionNumber}/${chartType}/${showMasterBar}/1/R13-R10-R08-R02/home-multiply-regional-resultados.html`
      );
    }
    if (childType === 'MUNICIPALES') {
      if (intialPath.includes('home-multiply-municipales-resultados.html')) {
        history.push(intialPath);
        return;
      }

      history.push(
        `/C108/${navigableMode}/2023/MUNICIPAL/${electionNumber}/${chartType}/${showMasterBar}/28079-08019-46250-41091/home-multiply-municipales-resultados.html`
      );
    }
  };
  const { elections } = params;

  const site = getSite();

  // Pinta las pestañas de navegación
  const getTabs = electionsParam => (
    <nav className="masterBarButtonsContainer">
      <ul className="masterBarButtons">
        {electionsParam.types.map(election => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
          <li
            key={election.name}
            className={`masterBarButton ${
              election.name === ELECTION_NAME_VALUES[type] ? `current` : ''
            }`}
            onClick={event => goToDetails(election, event)}
          >
            <a href={election.paths[site]} target="_parent" rel="noreferrer">
              {election.name}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );

  // Cabecera con misma versión desktop y móvil y tabs opcionales
  if (optionalTitleRegular) {
    return (
      <header className="masterBar">
        <h2 className="masterBarTitle masterBarTitle--mobile">
          <span>{optionalTitleRegular}</span>
          <strong>{optionalTitleStrong}</strong>
        </h2>
        <h2 className="masterBarTitle masterBarTitle--desktop">
          <span>{optionalTitleRegular}</span>
          <strong> {optionalTitleStrong}</strong>
        </h2>
        {isOpenedTabs ? getTabs(elections) : null}
      </header>
    );
  }

  // Módelo solo para la cabecera génerica (Versión móvil y desktop distintas)
  return (
    <header className="masterBar">
      <h2 className="masterBarTitle masterBarTitle--mobile">
        {isOpenedTabs ? elections.titleRegularMobile : elections.titleRegular}{' '}
        <strong>{elections.titleStrong}</strong>
      </h2>
      <h2 className="masterBarTitle masterBarTitle--desktop">
        {elections.titleRegular} <strong>{elections.titleStrong}</strong>
      </h2>
      {elections.types && elections.types.length > 0 && isOpenedTabs
        ? getTabs(elections)
        : null}
    </header>
  );
};

MasterBar.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  params: PropTypes.shape({
    elections: PropTypes.shape({
      titleRegular: PropTypes.string,
      titleStrong: PropTypes.string,
      types: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          paths: PropTypes.shape({})
        })
      ),
      titleRegularMobile: PropTypes.string
    })
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      type: PropTypes.string,
      electionNumber: PropTypes.string,
      navigableMode: PropTypes.string,
      chartType: PropTypes.string,
      showMasterBar: PropTypes.string
    })
  }),
  optionalTitleRegular: PropTypes.string,
  optionalTitleStrong: PropTypes.string
};

MasterBar.defaultProps = {
  history: {},
  params: {},
  match: {},
  optionalTitleRegular: '',
  optionalTitleStrong: ''
};

export default MasterBar;
